/**
 * 基础菜单 一物一码
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>一物一码</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选-->


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-select v-model="formInline.category_id" clearable placeholder="请选择分类" @change="search($event)">
          <el-option
            v-for="item in category"
            :key="item.category_id"
            :label="item.category_name"
            :value="item.category_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">批量添加</el-button>
        <el-button size="small" type="primary" icon="el-icon-download" @click="exportFormVisible=true">批量导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="article_id" label="活码ID" width="70">
      </el-table-column>
      <el-table-column prop="article_id" label="访问链接" min-width="100">
        <template slot-scope="scope">
          <div>{{ rukouurl(scope.row.article_id) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="category_name" label="分类名称" width="100">
      </el-table-column>
      <el-table-column prop="redirect" label="跳转地址" min-width="100">
      </el-table-column>
      <el-table-column prop="yuzhi" label="阈值" width="80">
      </el-table-column>
      <el-table-column prop="fwl" label="访问量" width="80">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="分类" prop="category_name">
          <el-select v-model="editForm.category_id" placeholder="请选择分类">
            <el-option
              v-for="item in category"
              :key="item.category_id"
              :label="item.category_name"
              :value="item.category_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转地址" prop="redirect">
          <el-input size="small" v-model="editForm.redirect" auto-complete="off" placeholder="请输入跳转地址"></el-input>
        </el-form-item>
        <el-form-item label="生成数量" prop="redirect">
          <el-input size="small" v-model="editForm.shuliang" auto-complete="off" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="阈值" prop="yuzhi">
          <el-input size="small" v-model="editForm.yuzhi" auto-complete="off" placeholder="请输入阈值"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" :disabled="savedis" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 批量导出对话框-->
    <el-dialog
      title="导出"
      :visible.sync="exportFormVisible"
      :close-on-click-modal="false"
      width="50%"
      :before-close="handleClose">
      <span>
        <el-input v-model="baseurl" placeholder="请输入网址,例如:https://www.abcd.com/,结尾一定要带反斜杠(/)"></el-input>
        <p v-show="urllizhi">{{ '生成例子：' + baseurl + 'yima/342ds3dg3g35925' }}</p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExport">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { huomaList, huomaSave, huomaExport, huomaDelete, categoryList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import base64 from 'base-64'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      savedis: false,
      baseurl: '', //导出时的基础域名
      urllizhi: false, //生成的到处域名演示
      editFormVisible: false, //控制编辑页面显示与隐藏
      exportFormVisible: false, //控制导出页面显示与隐藏
      title: '添加',
      editForm: {
        category_id: '',
        redirect: '',
        shuliang: '',
        yuzhi:'',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        category_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        redirect: [
          { required: true, message: '请输入跳转链接', trigger: 'blur' }
        ],
        shuliang: [{ required: true, message: '请输入生成数量', trigger: 'blur' }],
        yuzhi: [{ required: true, message: '请输入阈值', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        category_id: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      category: [], //分类数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if(this.$route.params.category_id > 0 ){
      this.formInline.category_id = this.$route.params.category_id
    }
    this.getdata(this.formInline)
    this.getcategory()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      huomaList(parameter)
        .then(res => {
          this.loading = false
          if (res.code == '0') {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    getcategory(){
      categoryList()
        .then(res => {
          this.loading = false
          if (res.code == '0') {
            this.category = res.data
          }
        })
        .catch(err => {
          this.$message.error('分类加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search(value) {
      this.formInline.page = 1
      this.formInline.category_id = value
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function() {
      this.editFormVisible = true
      this.title = '添加'
      this.editForm.category_id = ''
      this.editForm.redirect = ''
      this.editForm.shuliang = ''
      this.editForm.yuzhi = ''
    },
    //导出数据
    handleExport(){
        this.exportFormVisible = false
        if(this.baseurl == ''){
          this.$message.error('网址不能为空')
          return false
        }
        window.open(this.$baseUrl + "/api/huoma/export?category_id=" + this.formInline.category_id + '&baseurl=' + this.baseurl)
        this.baseurl = ''
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          this.savedis = true
          huomaSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              this.savedis = false
              if (res.code == 1) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '成功添加' + res.count +'条记录'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('部分生成失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          huomaDelete(row.huomaId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    //关闭导出对话框
    handleClose(done){
       this.baseurl = ''
       done()
    }
  },
  computed: {
    //入口URL
    rukouurl(){
        return (value)=>{
          let id = base64.encode( (Number(value) + 122) * 5 + 200002 )
//          return this.$baseUrl + '/yima/'+ id
            return 'http(s)://导出网址/yima/'+ id
        }
    }
  },
  watch: {
    baseurl: function(newdata,olddata){
      if(newdata != ''){
        this.urllizhi = true
      }else{
        this.urllizhi = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/yima/Huoma.vue